import { render, staticRenderFns } from "./UsersActions.vue?vue&type=template&id=48191937&scoped=true&"
import script from "./UsersActions.vue?vue&type=script&lang=js&"
export * from "./UsersActions.vue?vue&type=script&lang=js&"
import style0 from "./UsersActions.vue?vue&type=style&index=0&id=48191937&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48191937",
  null
  
)

export default component.exports